import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryParam } from 'builder/hooks/useQueryParam'
import Spinner from 'builder/components/Spinner'
import { useMutationMagicAuth } from './hooks/useMutationMagicAuth'
import { SpinnerContainer } from './styles'

export const MagicLinkAuthAndRedirectJobAlert = () => {
  const [token] = useQueryParam('magic-link-token')
  const mutationMagicAuth = useMutationMagicAuth()
  const navigate = useNavigate()

  useEffect(() => {
    async function requestMagicLink() {
      if (token) {
        try {
          await mutationMagicAuth.mutateAsync({ token })
        } catch (error) {
          console.warn('Invalid token or expired token')
        }
      }
      navigate(window.location.pathname.replace('/app/', '/email/'))
    }
    requestMagicLink()
  }, [token])

  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  )
}
